import React, { PureComponent } from 'react';
import { Button } from 'reactstrap';
import { I, webRoot } from '../../../common/v5/config';
import { Area } from '../../../components/v5/ManualErrand';
import {
	TextInputRow,
	ReadOnlyTextField,
	CustomInputRow
} from '../../../reactcomponents/Form';
import {
	LabelToggleSwitch as ToggleSwitch
} from '../../../components/v5/ToggleSwitch';
import { Spinner } from '../../../reactcomponents/Spinner'
import { INPUT_EMPTY_WARNING, FORM_SUBMIT_EMPTY_WARNING } from "../../../common/v5/constants"
import update from 'immutability-helper';
import { windowPopupCenter } from '../../../common/v5/helpers';
import { UnnestedAreaSingleSelect } from '../../../reactcomponents/Dropdown';
import { TXT_NO_SELECTION } from '../../../common/v5/receiptGreetingConstants';


const helperForName = <div>
	<div>{I("This is the name that will be displayed in the list of accounts. This name is only used to help you identify the account.")}</div>
</div>

const helperForArea = <div>
	<div>{I("An area must be chosen because the authenticated Google Play account needs to be connected with an area.")}</div>
</div>

const helperForEnable = <div>
	<div>{I("If the account is enabled the system will fetch posts and comments from your Google Play timeline.")}</div>
	<br/>
	<div>{I("If it is not enabled the system will not do anything with the account.")}</div>
</div>

const helperForPackage = <div>
	<div>{I("Here you choose which Google Play android apps package that should be managed in Cention Workflow.")}</div>
	<br/>
	<div>{I("Cention Workflow will automatically fetch all posts, comments and ratings made after you have activated your account so that you can immediately start answering questions.")}</div>
	<br/>
	<div>{I("Please Note")}</div>
	<div>{I("If no Google Play android package were found with the Google Play account you used to authenticate with, it either means your Google Play account does not have any android application it can manage, or that an error have occurred.")}</div>
	<br/>
	<div>{I("If the problem persists and you are confident that your Google Play account has an android application it can manage, please contact Cention Support.")}</div>
</div>


const helperForAuthorization = <div>
	<div>{I("For the system to be able to manage your Google Play comments, you need to give the Cention application permission to do that.")}</div>
	<br/>
	<div>{I("When you click the button a new window will open where you will be asked to login to gmail account. After you have logged in you will be asked to accept the permissions the Cention Google Play application requires to manage comments from the videos and channels")}</div>
	<br/>
	<div>{I("Click the Authorize button to start the authorization process.")}</div>
</div>



const GooglePlayAuthButton = ({label, onFetchKey}) => {
	const handleClick = () => {
		if(onFetchKey) {
			onFetchKey();
		}
		const msg = I("Google Play authentication failed! Please contact Cention support.");
		let callbackURL = webRoot + "media/googleplay/handletoken";
		$.post(webRoot + 'googleplay/oauthurl', {redirectUrl: callbackURL})
		.then(function( oauthUrl ) {
			console.log("oauthUrl =" + oauthUrl);
			if( oauthUrl != "" ){
				windowPopupCenter(oauthUrl, 800, 600);
			}else{
				alert(msg);
			}
		})
		.fail(function(err){
			alert(msg);
		});
	}
	return (
		<Button className="btn-outline blue btn-icon-text"
			outline
			color="primary"
			onClick={handleClick}
			title={label}
		>
			<i className={"icon-member"} />
			<span className="label">{label}</span>
		</Button>
	);
};

export default class AccountGooglePlayForm extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			id: 0,
			name: "",
			connectedArea: "",
			authenticated: false,
			authLoading: false,
			showAuthBtn: true,
			reqInputs: {
				name: {touched:false},
				packagename: {touched:false},
			}
		};

	}

	componentDidMount = () => {
		let ds = this.props.input;
		if(typeof ds.id !== 'undefined' && ds.id > 0){
			this.setState({
				id: ds.id,
				name: ds.name,
				connectedArea: ds.connectedArea,
				path: ds.path,
				authenticated: true,
			});
		}
	}

	componentWillUnmount = () =>{
		$('body').off('googlePlay.authorization.accounts');
	}

	handleSelectArea = (val) => {
		this.props.onChangeAdminInput("selectedArea", val, this.props.view);
	}
	

	handleToggle = (value, field) => {
		this.props.onChangeAdminInput(field, value)
	}

	getParameterByName = (name, url) => {
		if (!url) url = window.location.href;
		name = name.replace(/[\[\]]/g, "\\$&");
		var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
			results = regex.exec(url);
		if (!results) return null;
		if (!results[2]) return '';
		return decodeURIComponent(results[2].replace(/\+/g, " "));
	}

	handleAuth = (e) => {
		$("body").on('googlePlay.authorization.accounts', function(e, rd) {
			const msg = I("We are really sorry, the Google Play authentication failed. Please contact Cention Support.");
			let code = this.getParameterByName("code", rd);
			console.log("Code = ", code);
			this.setState({authLoading: true});
			if(code != ""){
				$.post(webRoot + 'googleplay/accesstoken', {code: code, aid: this.state.id, accName: this.state.name})
				.done(function( data ) {
					// let cl = [{id: 0, value: I("Select Google Play channel")}];
					// data.channelList.forEach((v,i) => {
					// 	cl.push({id: v.id, value: v.name});
					// });
					this.setState({
						id: data.id,
						// accountName: data.accName, //handled on input
						path: data.filepath,
						authLoading: false,
						authenticated: true
					});
					this.props.onChangeAdminInput("id",data.id);
					this.props.onChangeAdminInput("path",data.filepath);
				}.bind(this))
				.fail(function(err){
					this.setState({authLoading: false, authenticated:false});
					setTimeout(() => alert( msg ),100);
				}.bind(this));
			}else{
				this.setState({authLoading: false, authenticated:false});
				alert(msg);
			}
		}.bind(this));
	}

	handleFieldWarning = (e) => {
		let field = e.target.name;
		let reqInputs = this.state.reqInputs;
		reqInputs = update(reqInputs,{
			[field]: {
				touched:{$set: true}
			},
		})
		this.setState({reqInputs:reqInputs})
	}

	handleSubmit = (e) => {
		e.preventDefault();
		let reqInputs = this.state.reqInputs;
		let input = this.props.input;
		let valid = true;
		if (input.selectedArea === "0") {
			return alert(I("Please select area"));
		}
		$.each(reqInputs, (field, v)=>{
			reqInputs = update(reqInputs,{
				[field]: {
					touched:{$set: true}
				},
			})
			if(input[field] === "" || input[field] === undefined) {
				valid = false;
			}
		});
		this.setState({reqInputs:reqInputs})
		if(!this.state.authenticated) {
			return alert(I("Account not authorized. Please try again"))
		}
		if(valid){
			this.props.onSave();
		} else {
			alert(FORM_SUBMIT_EMPTY_WARNING);
		}
	}

	render() {
		const {
			areaList
			, activeId
			, input
			, onHandleTextInputChange
			, hidden
			, baseButtons
		} = this.props;

		let selectedArea = parseInt(input.selectedArea, 10);
		const st = this.state;
		const field = st.reqInputs;
		const warnTxt = INPUT_EMPTY_WARNING;

		let authorizationStr = st.authenticated ? I("Re-authorize") : I("Authorize") ;
		
		return (
			<form onSubmit={this.handleSubmit} className="admin-one-form edit-admin-form" hidden={hidden}>
				<CustomInputRow
					id={"area"}
					name={"area"}
					label={I('Area')}
					className={"admin-dropdown-select"}
					mandatory={true}
					helper={helperForArea}
				>
					<UnnestedAreaSingleSelect
						data={areaList}
						invalidSelectedText={TXT_NO_SELECTION}
						onSelect={this.handleSelectArea}
						selected={selectedArea}
						nested={{key: 'Areas'}}
						idFields={{id: "Id", name: "Name"}}
					/>
				</CustomInputRow>
				<TextInputRow
					id={"name"}
					name={"name"}
					className="admin-text-input"
					label={I("Name")}
					value={input.name || ""}
					onChange={onHandleTextInputChange}
					mandatory={true}
					warning={(!input.name && field.name.touched) && warnTxt}
					onBlur={this.handleFieldWarning}
					helperTxt={helperForName}
				/>
				<ToggleSwitch
					id={"enable"}
					name={"enable"}
					data-qa-id="enableGooglePlay"
					label={I("Activated")}
					checked={input.enable}
					onClick={this.handleToggle}
					listWrap={false}
					className="admin-text-input"
					helperTxt={helperForEnable}
				/>
				<TextInputRow
					id={"packagename"}
					name={"packagename"}
					className="admin-text-input"
					label={I("Google Play package")}
					value={input.packagename || ""}
					onChange={onHandleTextInputChange}
					mandatory={true}
					warning={(!input.packagename && field.packagename.touched) && warnTxt}
					onBlur={this.handleFieldWarning}
					helperTxt={helperForPackage}
				/>
				{st.showAuthBtn &&
				<CustomInputRow
					id={"authorization"}
					name={"authorization"}
					label={I("Authorization")}
					className={"admin-auth-button"}
					helper={helperForAuthorization}
					mandatory={true}
					hide={activeId === 0 && st.authenticated}
				>
					<GooglePlayAuthButton onFetchKey={this.handleAuth} label={authorizationStr}/>
				</CustomInputRow>}
				{st.authLoading 
				? <div className='center p-3'><Spinner/></div>
				: <ReadOnlyTextField
					id={"authentication"}
					name={"authentication"}
					className="admin-text-input"
					label={I("Google Play account")}
					value={I("@Authenticated")}
					hidden={!st.authenticated}
					mandatory={true}
				/>}
				{baseButtons}
			</form>
		)
	}
}